A candidate's preferences in an ideal position.
